import { Separator } from 'telia-front-react';
import * as React from 'react';
import { CALLS_AND_MESSAGES_SERVICE_GROUP_ID } from '../../RoamingInterfaces';
import GroupServiceTable from './GroupServiceTable';
import ServiceGroupComments from './ServiceGroupComments';

const CallsServiceGroup = (): JSX.Element => {
  return (
    <>
      <GroupServiceTable serviceGroupId={CALLS_AND_MESSAGES_SERVICE_GROUP_ID} />
      <Separator spacing="small" color="invisible" />
      <ServiceGroupComments serviceGroupId={CALLS_AND_MESSAGES_SERVICE_GROUP_ID} />
    </>
  );
};

export default CallsServiceGroup;
